import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QAType } from '../models';

@Injectable({
  providedIn: 'root'
})
export class QaTypeApiService {
  constructor(protected _http: HttpClient) {}

  public GetQATypeAsync(): Observable<QAType[]> {
    return this._http.get<QAType[]>(`${environment.apiEndpoint}/QAType/GetQATypeAsync`);
  }
}
